module.exports = __webpack_public_path__ + "static/yahoo-news-light@3x-d79c9a711f5f1319749fd294d09704b8.png";